export default __webpack_public_path__ + "static/10560-bf6bf2597ef0be1212fe23ee556114d2.jpg";